module.exports = __webpack_public_path__ + "img/NivelLiquidoBlack.5b870320.svg";